module.exports = __webpack_public_path__ + "static/media/img_youggy.ba28da7d.png";